import { Box, Toolbar } from '@mui/material'
import React from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import {
  BarChart,
  DataTable,
  HorizontalChart,
  SelectField,
  ToolbarComponent,
} from '../../../../../components'
import { expensesHeadCells } from '../../../../../shared/data/headCells'
import { ExpenseForm } from './components/ExpenseForm'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { ExpenseDetail } from './components/ExpenseDetail'
import { useState } from 'react'
import { SelectPopUp } from '../../../../../components/Toolbar/Toolbar'
import { useSelector } from 'react-redux'
import { highestInt } from '../../../../../shared/utils/constants'
import { InfoField } from '../School/PopOver/SchoolInfo'

const selectOptions = [
  { label: 'Salary', value: 'Salary' },
  { label: 'Rent', value: 'Rent' },
  { label: 'Vehicle', value: 'Vehicle' },
  { label: 'Function', value: 'Function' },
  { label: 'Maintenance', value: 'Maintenance' },
  { label: 'Others', value: 'Others' },
]

export const Expense = () => {
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear().toString())
  const [schoolName, setSchoolName] = React.useState('')

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const [page, setPage] = React.useState(1)
  const [openForm, setOpenForm] = React.useState(false)
  const [search, setSearch] = React.useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [detail, setDetail] = useState(false)
  const [update, setUpdate] = useState(false)

  const { data: expenseData, count ,refetch} = useGlobal({
    userUrl: `${urls.EXPENSE}?school_id=${customRole == 'Admin'  ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&category=${selectedCategory}&keyword=${search}`,
  })
  // const { data: searchExpense, count: searchCount } = useGlobal({
  //   userUrl: `${urls.EXPENSE_SEARCH}${search}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}&page${page}&limit=${rowsPerPage}`,
  // })
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  const rowData =  expenseData
  const pagecount =  count
  const handleClose = () => {
    if (update) {
      setUpdate(false)
    } else {
      setOpenForm(false)
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Expenses'} subtitle={'Finance / Expenses'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <Box className="chart-area" mt={3}>
        <div style={{ width: '60%' }} className="chart-container">
          <BarChart onClick={() => setOpenForm(true)} />
        </div>
        <div style={{ width: '37%' }} className="chart-container">
          <HorizontalChart selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
        </div>
      </Box>

      <Box mt={6}>
        <ToolbarComponent
          handleOpen={() => setOpenForm(true)}
          search={search}
          setSearchItem={setSearch}
          setPage={setPage}
        >
          <SelectPopUp
            title={'Category'}
            selectedStatus={selectedCategory}
            setSelectedStatus={setSelectedCategory}
            selectOptions={selectOptions}
          />
        </ToolbarComponent>
        <DataTable
          headCells={expensesHeadCells}
          rowData={rowData}
          expense
          pageFee={page}
          setPageFee={setPage}
          setUpdate={setUpdate}
          pageCount={pagecount}
          pages
          refetch={refetch}
          handleDetailOpen={() => setDetail(true)}
        />
      </Box>
      {detail && <ExpenseDetail open={detail} handleClose={() => setDetail(false)} />}
      {(openForm || update) && (
        <ExpenseForm
          open={openForm || update}
          update={update}
          handleClose={handleClose}
          customRole={customRole}
          userSchoolId={userSchoolId}
          refetch={refetch}
        />
      )}
    </div>
  )
}
